
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import React from 'react'
import ViewContainer from './View/ViewContainer'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Game, Firebase } from '../../../Core'

import * as indicatorsSelectors from '../../Indicators/indicators.selectors'
import * as indicatorsActions from '../../Indicators/indicators.actions'
import * as MiningActions from '../../Mining/mining.actions'
import * as phaseActions from '../../Phases/phases.actions'
import * as surveyActions from '../../Survey/survey.actions'

import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import * as MapActions from '../map.actions'
import * as MapSelectors from '../map.selectors'
import * as PhasesSelectors from '../../Phases/phases.selectors'
import * as savePointSelector from '../../SavePoint/savePoint.selectors'
import * as settingsSelectors from '../../Settings/settings.selectors'

import * as profileActions from '../../Profile/profile.actions'

import IndicatorContainer from '../../Indicators/IndicatorContainer'
import SessionCounter from '../../Components/SessionCounter'
import UserShield from '../../Components/UserShield'
import PointsAlert from '../../PointsManager/PointsAlert'
import BasicToast from '../../Toast/BasicToast'
import SettingsMenuButton from '../../Settings/SettingsMenuButton'
import HelpButton from '../../Settings/HelpButton'
import Feed from '../../Ranking/Feed'
import * as utils from '../../Ranking/ranking.utils'

import * as SavePointSelectors from '../../SavePoint/savePoint.selectors'

import TileButton from './TilePopup/TileButton'
import GlobeAlert from '../../Components/GlobeAlert'
import DocumentsButton from '../../Documents/DocumentsButton/index'

class MapScreen extends React.Component {
  /****/

  constructor(props) {
    super(props)
    this.state = {
      expanded: props.isPortable,
      changeTurnEnable: false,
    }
  }

  // Optimize re-renders with shouldComponentUpdate
  shouldComponentUpdate(nextProps, nextState) {
    // State changes always trigger re-render
    if (this.state !== nextState) {
      return true
    }

    // Check critical props that affect rendering
    const criticalProps = [
      'currentPhase', 'visitorMap', 'isAttacking', 'playerData',
      'currentUser', 'userIndicators', 'visitorIndicators', 'groupData'
    ]

    for (const prop of criticalProps) {
      if (this.props[prop] !== nextProps[prop]) {
        return true
      }
    }

    // Deep comparison for complex objects only when necessary
    if (JSON.stringify(this.props.userData) !== JSON.stringify(nextProps.userData)) {
      return true
    }

    return false
  }

  componentDidMount() {
    const { getCountDisputes, loadSurvey } = this.props
    getCountDisputes()
    loadSurvey()
  }

  componentDidUpdate() {
    const { currentPhase, visitorMap, groupData, userData } = this.props
    const { changeTurnEnable } = this.state
    const isLastTurn = userData.turn % groupData.maxTurns === 0

    if (
      currentPhase == 3 &&
      !changeTurnEnable &&
      !isLastTurn &&
      !visitorMap.mapId &&
      !groupData.endGame
    ) {
      setTimeout(() => {
        this.setState({ changeTurnEnable: true })
      }, 4000)
    }
  }

  handleLoadPlayer(uid) {
    const { loadVisitorMap, visitorMap } = this.props
    if (!visitorMap.mapId) {
      loadVisitorMap(uid)
    }
  }

  displayButton(label, icon, action, disabled = false) {
    const { addHowlSound } = this.props
    
    const handleButtonAction = () => {
      icon ? addHowlSound('button_click_icon') : addHowlSound('button_click')
      if (action) action()
    }

    return (
      <TileButton
        key={label + '_' + icon}
        label={label}
        icon={icon}
        action={handleButtonAction}
        disabled={disabled}
      />
    )
  }
  renderMiningFinished() {
    const { currentPhase, addPopup, settings, nextPhase } = this.props
    let phase = currentPhase
    return (
      <div
        className="btn--orange"
        onClick={() =>
          !settings.mineDisclaimer && phase == 2
            ? addPopup('mining_change_phase_popup')
            : nextPhase()
        }
      >
        <span className="icon-rocket"> </span>
        <FormattedMessage id={'mining.goFase3'} />
      </div>
    )
  }
  renderUserButtons() {
    const {
      currentPhase,
      changeTurn,
      visitorMap,
      groupData,
      userData,
      counters: { qu_t: turn_questions, an_t: turn_answers },
    } = this.props
    const canGoNextPhase = turn_questions === 0 && turn_answers === 0
    const { changeTurnEnable } = this.state

    const isLastTurn = userData.turn % groupData.maxTurns === 0

    return (
      <div className="map--buttons">
        {currentPhase == 3 && !visitorMap.mapId && !groupData.endGame
          ? !isLastTurn
            ? this.displayButton(
                'phase.nextTurn',
                null,
                () => {
                  this.setState({ changeTurnEnable: false })
                  changeTurn()
                },
                !changeTurnEnable
              )
            : null
          : null}
        {canGoNextPhase && currentPhase == 2 ? this.renderMiningFinished() : null}
      </div>
    )
  }

  renderShield(data) {
    const { currentUser, rankingObfuscated } = this.props
    const cityLevel = 'map.buildings.city_level.' + (data.cityLevel ? data.cityLevel : 1)
    let obfuscated = rankingObfuscated == 'undefined' ? 'normal' : rankingObfuscated
    let name =
      obfuscated == 'obfuscated'
        ? utils.obfuscated(data.name, currentUser)
        : obfuscated == 'alias'
        ? data.name == currentUser.name
          ? data.name
          : data.alias
        : data.name
    return [
      data.colonyShield ? <UserShield key="shield" shield={data.colonyShield} /> : null,
      <div key="block_info" className="map--block__info">
        <span className="text username">{data.colonyName}</span>
        <span className="text">
          <FormattedMessage id={cityLevel} />
        </span>
        <span className="text">{name}</span>
        <span className="num">
          <span className="icon-settlers"></span>
          {data.settlers}
        </span>
      </div>,
    ]
  }

  handleBackToRanking() {
    const {
      addScreen,
      addHowlSound,
      setListenerType,
      setVisitorMap,
      setVisitorIndicators,
      clearSprites,
      backToRanking,
    } = this.props

    addHowlSound('button_click')
    addScreen('ranking_screen')
    backToRanking(true)

    setTimeout(() => {
      addHowlSound('button_click_icon')
      setListenerType(null)
      clearSprites()
      setVisitorMap({ visitorId: null, mapId: null, buildings: {}, removedRocks: {} })
      setVisitorIndicators(null)
      addHowlSound('button_click_icon')
    }, 1000)
  }

  renderUserHeader() {
    const {
      playerData,
      visitorInfo,
      userIndicators,
      getProfileBattles,
      currentUser,
      groupData,
      intl,
    } = this.props

    let visitingShield = (
      <div key="user_shield" className="map--block map--header">
        {this.renderShield(playerData)}
      </div>
    )

    return (
      <React.Fragment>
        {visitorInfo ? (
          <div
            key="back_button"
            onClick={() => this.handleBackToRanking()}
            className="position--absolute left top z-index1"
          >
            <div className="btn--back">
              <span className="icon-back"> </span>
            </div>
          </div>
        ) : null}
        {!visitorInfo ? (
          <div key="ownShield">
            <UserShield
              key="shield"
              openProfile={() => {
                if (!groupData.endGame) {
                  getProfileBattles()
                }
              }}
              shield={playerData.colonyShield}
              title={intl.formatMessage({ id: 'phase.tooltips.profile' })}
            />
            <div className="player--position">
              <div className="player--label">
                <FormattedMessage id="ranking.position" defaultMessage="position" />
              </div>
              <div className="player--position__item">{currentUser.position}º</div>
            </div>
          </div>
        ) : (
          visitingShield
        )}
        <IndicatorContainer
          indicators={userIndicators}
          isVisitor={false}
          key="indicators"
          position="position--absolute center top z-index5"
        ></IndicatorContainer>
      </React.Fragment>
    )
  }

  renderFooter() {
    const { visitorInfo, visitorIndicators } = this.props
    const { expanded } = this.state

    if (!visitorInfo || expanded) {
      return null
    }

    return (
      <React.Fragment>
        <div key="footer" className="map--block map--footer">
          {this.renderShield(visitorInfo)}
        </div>
        <IndicatorContainer
          indicators={visitorIndicators}
          isVisitor={true}
          key="indicators"
          position="position--absolute center bottom z-index5 markers--footer"
        ></IndicatorContainer>
      </React.Fragment>
    )
  }

  renderSurvey() {
    const { addScreen } = this.props
    addScreen('survey')
  }

  isLastTurnOfLastSession() {
    const {
      groupData: { session, sessions, maxTurns },
      userData: { turn },
    } = this.props

    return session === sessions && turn % maxTurns === 0
  }

  render() {
    const {
      alertData,
      visitorInfo,
      isAttacking,
      firebasePath,
      isPortable,
      currentPhase,
      counters: { qu_t: turn_questions, an_t: turn_answers },
    } = this.props
    const { expanded } = this.state
    const canGoNextPhase = turn_questions === 0 && turn_answers === 0

    return (
      <div className="map">
        {!expanded ? this.renderUserHeader() : null}
        <PointsAlert />
        <SessionCounter />
        <BasicToast />
        {process.env.DEBUG_MAP && (
          <div id="debug" className="map--debug">
            <div id="coordinates"></div>
          </div>
        )}
        {canGoNextPhase && currentPhase === 2 ? null : alertData && <GlobeAlert {...alertData} />}
        {this.renderUserButtons()}
        {visitorInfo && isAttacking ? (
          <div className="map--picture">
            <span className="map--picture__borders"> </span>
          </div>
        ) : null}
        <ViewContainer />
        <DocumentsButton key={'documents'} />
        <HelpButton key="help" />
        {isPortable ? (
          <div
            onClick={() => this.setState({ expanded: !expanded })}
            className="position--absolute left center z-index1 btn--collapse"
          >
            <div className="btn">
              <div className="btn--primary">
                <span className="icon-panels-collapse"> </span>
              </div>
            </div>
          </div>
        ) : null}
        <SettingsMenuButton key="settings" />
        {this.renderFooter()}
        {visitorInfo && !expanded ? (
          <Feed
            className="z-index6"
            firebasePath={firebasePath}
            user={visitorInfo}
            visitUser={true}
          />
        ) : null}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadVisitorMap: bindActionCreators(MapActions.loadVisitorMap, dispatch),
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
  removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
  setVisitorMap: bindActionCreators(MapActions.setVisitorMap, dispatch),
  getProfileBattles: bindActionCreators(profileActions.getProfileBattles, dispatch),
  setVisitorIndicators: bindActionCreators(indicatorsActions.setVisitorIndicators, dispatch),
  changeTurn: bindActionCreators(MapActions.changeTurn, dispatch),
  toggleAttack: bindActionCreators(MapActions.toggleAttack, dispatch),
  setListenerType: bindActionCreators(Firebase.actions.setListenerType, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  getCountDisputes: bindActionCreators(MiningActions.getCountDisputes, dispatch),
  clearSprites: bindActionCreators(MapActions.clearSprites, dispatch),
  backToRanking: bindActionCreators(MapActions.backToRanking, dispatch),
  nextPhase: bindActionCreators(phaseActions.nextPhase, dispatch),
  loadSurvey: bindActionCreators(surveyActions.loadSurvey, dispatch),
})
const mapStateToProps = (state) => ({
  playerList: Firebase.selectors.getPlayerList(state),
  myUID: Firebase.selectors.getOwnPlayerID(state),
  visitorMap: MapSelectors.getVisitorMap(state),
  visitorInfo: MapSelectors.getVisitorInfo(state),
  isAttacking: MapSelectors.getAttackState(state),
  isPortable: Game.selectors.isPortable(state),
  currentPhase: PhasesSelectors.getCurrentPhase(state),
  playerData: Firebase.selectors.getUserDataShield(state),
  settings: settingsSelectors.getSettings(state),
  currentUser: Firebase.selectors.getUserData(state),
  groupData: Firebase.selectors.getGroupData(state),
  userIndicators: indicatorsSelectors.getIndicators(state),
  visitorIndicators: indicatorsSelectors.getVisitorIndicators(state),
  userData: indicatorsSelectors.getUserData(state),
  alertData: SavePointSelectors.getAlertData(state),
  firebasePath: Firebase.selectors.getFirebasePath(state),
  surveyActive: savePointSelector.isSurveyCompleted(state),
  counters: indicatorsSelectors.getCountersData(state),
  rankingObfuscated: Firebase.selectors.getObfuscatedRankingFlag(state),
})

MapScreen.propTypes = {
  changeTurn: PropTypes.func,
  backToRanking: PropTypes.func,
  loadVisitorMap: PropTypes.func,
  setListenerType: PropTypes.func,
  removePopup: PropTypes.func,
  setVisitorMap: PropTypes.func,
  loadSurvey: PropTypes.func,
  setVisitorIndicators: PropTypes.func,
  settings: PropTypes.object,
  clearSprites: PropTypes.func,
  toggleAttack: PropTypes.func,
  getProfileBattles: PropTypes.func,
  playerList: PropTypes.object,
  isAttacking: PropTypes.bool,
  alertData: PropTypes.object,
  visitorMap: PropTypes.object,
  currentUser: PropTypes.object,
  nextPhase: PropTypes.func,
  counters: PropTypes.object,
  visitorInfo: PropTypes.object,
  myUID: PropTypes.string,
  currentPhase: PropTypes.number,
  playerData: PropTypes.object,
  groupData: PropTypes.object,
  visitorIndicators: PropTypes.array,
  userIndicators: PropTypes.array,
  isPortable: PropTypes.bool,
  userData: PropTypes.object,
  addPopup: PropTypes.func,
  addScreen: PropTypes.func,
  addHowlSound: PropTypes.func,
  firebasePath: PropTypes.string,
  getCountDisputes: PropTypes.func,
  surveyActive: PropTypes.bool,
  rankingObfuscated: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MapScreen))
